import { render, staticRenderFns } from "./BrandIndex.vue?vue&type=template&id=02c46262&scoped=true&"
import script from "./BrandIndex.vue?vue&type=script&lang=js&"
export * from "./BrandIndex.vue?vue&type=script&lang=js&"
import style0 from "./BrandIndex.vue?vue&type=style&index=0&id=02c46262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c46262",
  null
  
)

export default component.exports